// extracted by mini-css-extract-plugin
module.exports = {"root":"option-input_root__3kiM9","container":"option-input_container__2Rlh1","box":"option-input_box__3fVYd","dot":"option-input_dot__xYDJd","label":"option-input_label__DdqlC"};